// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { VERSION } from '@/constants';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import * as customComponentConfig from './shared/config/config-custom-components';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import AuditsService from './admin/audits/audits.service';

import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';

import LoginService from './account/login.service';
import AccountService from './account/account.service';

import '../content/scss/vendor.scss';
import AlertService from '@/shared/alert/alert.service';
import TranslationService from '@/locale/translation.service';
import ConfigurationService from '@/admin/configuration/configuration.service';
import UserService from '@/admin/users/users.service';

/* tslint:disable */

import AsuntoService from '@/entities/asunto/asunto.service';
import CelulaService from '@/entities/celula/celula.service';
import ParticipacionService from '@/entities/participacion/participacion.service';
import AreaService from '@/entities/area/area.service';
import PersonaService from '@/entities/persona/persona.service';
import BadgeService from '@/entities/badge/badge.service';
import AvatarService from '@/entities/avatar/avatar.service';
import RolService from '@/entities/rol/rol.service';
import PlataformaService from '@/entities/plataforma/plataforma.service';
import VueLoadImage from 'vue-load-image';
import Avataaars from 'vuejs-avataaars';
import ContactoService from '@/entities/contacto/contacto.service';
import TecnologiaService from '@/entities/tecnologia/tecnologia.service';
import { VueEditor } from 'vue2-editor';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VGrid from '@revolist/vue-datagrid';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';

import ProyectoService from '@/entities/proyecto/proyecto.service';
import PracticaService from '@/entities/practica/practica.service';
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
defineCustomElements(window);

config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
customComponentConfig.initCustomComponents(Vue);
Vue.use(Vue2Filters);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
Vue.component('vue-load-image', VueLoadImage);
Vue.component('avataaars', Avataaars);
Vue.component('VueEditor', VueEditor);
Vue.component('v-grid', VGrid);
Vue.component('multiselect', Multiselect);
const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, (<any>Vue).cookie, router);

axios
  .get('sentry/config')
  .then(res => {
    if (res.data && res.data.dsn) {
      let environment = 'local';

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      let tracesSampleRate: 1.0;

      if (res.data.environment) {
        environment = res.data['environment'];
      }

      if (res.data.tracesSampleRate) {
        tracesSampleRate = res.data['tracesSampleRate'];
      }

      Sentry.init({
        Vue,
        dsn: res.data['dsn'],
        beforeSend(event, hint) {
          // Check if it is an exception, and if so, show the report dialog
          if (event.exception) {
            let feedBackConfig;

            if (store.getters.account && store.getters.account.firstName) {
              const username = store.getters.account.lastName
                ? `${store.getters.account.firstName} ${store.getters.account.lastName}`
                : store.getters.account.firstName;

              feedBackConfig = { eventId: event.event_id, user: { name: username, email: store.getters.account.email } };
            } else {
              feedBackConfig = { eventId: event.event_id };
            }

            Sentry.showReportDialog(feedBackConfig);
          }
          return event;
        },
        integrations: [
          new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ['localhost', 'crew.dev.k8s-conacyt.xyz', 'crew.crip.conacyt.mx', /^\//],
          }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate,
        environment,
        release: VERSION,
      });
    } else {
      console.log('Sentry sin activar');
    }
  })
  .catch(err => {
    console.error('Error al realizar la configuración de sentry');
    console.error(err);
  });

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,

    auditsService: () => new AuditsService(),

    healthService: () => new HealthService(),

    configurationService: () => new ConfigurationService(),
    userService: () => new UserService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,
    asuntoService: () => new AsuntoService(),
    celulaService: () => new CelulaService(),
    participacionService: () => new ParticipacionService(),
    areaService: () => new AreaService(),
    personaService: () => new PersonaService(),
    badgeService: () => new BadgeService(),
    avatarService: () => new AvatarService(),
    rolService: () => new RolService(),
    plataformaService: () => new PlataformaService(),
    contactoService: () => new ContactoService(),
    tecnologiaService: () => new TecnologiaService(),
    proyectoService: () => new ProyectoService(),
    practicaService: () => new PracticaService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
  },
  i18n,
  store,
});
